import { Link } from 'react-router-dom';
import WinelandsImage from './assets/Winelands.jpg';

function CapeWinelandsPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage winelands-hero">
        <div className="hero-content">
          <h1>Ebamba's Exclusive Cape Winelands Tour</h1>
          <p>Indulge in world-class wines amidst breathtaking vineyard landscapes.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">Sip, Savor, and Explore the Winelands</h2>
          <div className="content-intro">
            <img src={WinelandsImage} alt="Cape Winelands Tour" className="tour-main-image" />
            <p>Journey with Ebamba Travel & Tours into the heart of South Africa's picturesque Cape Winelands. This region, renowned for its exquisite wines and stunning scenery, offers a perfect blend of natural beauty, historical charm, and gastronomic delights. Our personalized tour takes you to acclaimed wine estates in Stellenbosch, Franschhoek, or Paarl, tailored to your preferences.</p>
            <p>Beyond wine tasting, explore quaint towns with Cape Dutch architecture, enjoy gourmet lunches, and immerse yourself in the serene beauty of rolling vineyards backed by majestic mountains. It's an experience designed for relaxation, indulgence, and cultural appreciation.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect on Your Winelands Tour</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-wine-glass-alt"></i>
              <h4>Premium Wine Tastings</h4>
              <p>Visit 3-4 carefully selected wine estates for guided tastings of award-winning wines.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-cheese"></i>
              <h4>Gourmet Pairings</h4>
              <p>Optional cheese, biltong, or chocolate pairings to enhance your wine tasting experience.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-utensils"></i>
              <h4>Fine Dining Lunch</h4>
              <p>Enjoy a leisurely lunch at a vineyard restaurant, with options ranging from casual to gourmet.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-building"></i>
              <h4>Historic Towns</h4>
              <p>Explore the charming streets of Stellenbosch or Franschhoek, known for their unique shops and art galleries.</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Happy Connoisseurs</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"The Winelands tour organised by Ebamba was pure luxury. Every vineyard chosen was magnificent, and the wine was divine. Our guide was so knowledgeable about the region."</p>
              <span>– Isabella C. from Italy</span>
            </div>
            <div className="testimonial-card">
              <p>"A perfect day of relaxation and indulgence. The scenery was as beautiful as the wine. Ebamba truly crafted an unforgettable experience."</p>
              <span>– Paul V. from Netherlands</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Book Your Winelands Escape</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CapeWinelandsPage;
